// extracted by mini-css-extract-plugin
export var img = "BandSlider-module--img--accbd";
export var marquee = "BandSlider-module--marquee--2f67e";
export var marqueeGroup = "BandSlider-module--marqueeGroup--35434";
export var root = "BandSlider-module--root--74ca7";
export var scrollX = "BandSlider-module--scroll-x--149fd";